import { PHONE_W, PHONE_H } from "./PhoneFrame";

const LABEL_H = 50;
const PADDING = 50;
const MIN_SCALE = 0.25;
const MAX_SCALE = 1;

const ScaledPreview = ({ availableHeight, label, children }) => {
  const totalH = PHONE_H + LABEL_H;
  const raw =
    availableHeight != null ? (availableHeight - PADDING) / totalH : 1;
  const scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, raw));

  return (
    <div
      className="relative shrink-0"
      style={{
        width: PHONE_W * scale,
        height: totalH * scale,
      }}
    >
      <div
        className="absolute top-0 left-0 origin-top-left"
        style={{
          width: PHONE_W,
          height: totalH,
          transform: `scale(${scale})`,
        }}
      >
        {children}
        <p className="text-md font-semibold text-zinc-500 text-center mt-7">
          {label}
        </p>
      </div>
    </div>
  );
};

export default ScaledPreview;
